import apiClient from "../plugins/axios-instance";
import Properties from "../properties";

const API_URL = "https://karyawan." + Properties.DOMAIN_URL + "/api/v1";

export default class AdminAPIService {
  constructor() { }

  static getAll = (limit, page) =>
    apiClient.get(API_URL + "/member-admins/" + "limit/" + limit + "?page=" + page);
    
  static filter = (body, page) => {
    return apiClient.get(
      API_URL + "/member-admins/searching/filter-admin?page=" + page,
      { params: body }
    );
  }
  
  static getByNIK = (nik) =>
    apiClient.get(API_URL + "/member-admins/nik/" + nik);
    
  static getByID = (id) =>
    apiClient.get(API_URL + "/member-admins/by-id/" + id);
    
  static edit = (kode, admin) =>
    apiClient.put(API_URL + "/member-admins/" + kode, admin);
    
  static create = (notif) =>
    apiClient.post(API_URL + "/member-admins", notif);
    
  static delete = (kode, nik) =>
    apiClient.delete(API_URL + "/member-admins/" + kode, {
      params: {
        user_update: nik,
      }
    });
}
